import { NgModule } from '@angular/core';
import { PreloadAllModules, Route, RouterModule, Routes } from '@angular/router';
import { AlertProfilePictureComponent } from './alert-profile-picture/alert-profile-picture.component';
import { AlertUnlockLevelComponent } from './alert-unlock-level/alert-unlock-level.component';
import { AllPathsV2Component } from './all-paths-v2/all-paths-v2.component';
import { AuthGuardService } from './auth/auth-guard.service';
import { CloseoutSurveyWelcomeComponent } from './closeout-survey/closeout-survey-welcome.component';
import { CloseoutSurveyComponent } from './closeout-survey/closeout-survey.component';
import { DailyContentV2Component } from './daily-content-v2/daily-content-v2.component';
import { DayPartSelectComponent } from './day-part-select/day-part-select.component';
import { DeletionPageComponent } from './deletion-page/deletion-page.component';
import { FaqComponent } from './faq/faq.component';
import { FullScreenAudioComponent } from './full-screen-audio/full-screen-audio.component';
import { FullScreenFeedComponent } from './full-screen-feed/full-screen-feed.component';
import { FullScreenPostComponent } from './full-screen-post/full-screen-post.component';
import { FullScreenRoutineComponent } from './full-screen-routine/full-screen-routine.component';
import { FullScreenVideoComponent } from './full-screen-video/full-screen-video.component';
import { MobileWeldonescreenComponent } from './mobile-weldonescreen/mobile-weldonescreen.component';
import { FullScreenDocumentComponent } from './my-library/full-screen-document.component';
import { FullScreenReflectionComponent } from './my-library/full-screen-reflection/full-screen-reflection.component';
import { FullScreenStepComponent } from './my-library/full-screen-step.component';
import { MyLibraryComponent } from './my-library/my-library.component';
import { DailyStepsContentModalComponent } from './new-design/daily-steps-content-modal/daily-steps-content-modal.component';
import { UpdatedHomeComponent } from './new-design/updated-home/updated-home.component';
import { YourPathComponent } from './new-design/your-path/your-path.component';
import { YourProgressComponent } from './new-design/your-progress/your-progress.component';
import { OnboardingSurveyComponent } from './onboarding-survey/onboarding-survey.component';
import { AchievementsPageComponent } from './pages/achievement/achievements-page.component';
import { MobileChatBoardComponent } from './pages/mobile-chat-board/mobile-chat-board.component';
import { NotificationsSettingsComponent } from './pages/notifications-settings/notifications-settings.component';
import { PathSelectComponent } from './path-select/path-select.component';
import { RoutineCalendarComponent } from './routine-v2/routine-calendar/routine-calendar/routine-calendar.component';
import { SignInComponent } from './sign-in/sign-in.component';
import { SignUpComponent } from './sign-up/sign-up.component';
import { StatListComponent } from './stat/stat-list.component';
import { UserComponent } from './user/user.component';
import { VideoDetailsComponent } from './video-details/video-details.component';
import { WebFaqComponent } from './web-faq/web-faq.component';
import { WeldonescreenComponent } from './weldonescreen/weldonescreen.component';
import { DailyStepsContentMobileV2Component } from './new-design/daily-steps-content-mobile-v2/daily-steps-content-mobile-v2.component';
import { DailyStepsContentWebModalV2Component } from './new-design/daily-steps-content-web-modal-v2/daily-steps-content-web-modal-v2.component';
import { WrongLoginLinkComponent } from './pages/wrong-login-link/wrong-login-link.component';

const routes: Routes = [
  {
    //   path: '',
    //   redirectTo: 'login',
    //   pathMatch: 'full', canActivate: [AuthGuardService]
    // } as Route,
    path: '',
    redirectTo: 'main',
    pathMatch: 'full'
  },
  {path: 'video-library', component:FullScreenVideoComponent},
  {path: 'audio-library', component:FullScreenAudioComponent},
  {path: 'video', component: VideoDetailsComponent},
  {path: '', component: SignInComponent},
  {path: 'splash', component: SignInComponent},
  {path: 'login/:pathGroupName', component: SignInComponent},
  {path: 'login/:code/:state', component: SignInComponent},
  {path: 'login', component: SignInComponent},
  {path: 'signup', component: SignUpComponent},
  {path: 'signup/:pathGroupName/:pathId', component: SignUpComponent},
  {path: 'faq', component: FaqComponent},
  {path: 'faqs', component: WebFaqComponent},
  {path: 'all-paths', component: AllPathsV2Component},
  {path: 'onboarding', component: OnboardingSurveyComponent, canActivate: [AuthGuardService]},
  {path: 'open-question',component: FullScreenFeedComponent},
  {path:'open-post-feed',component:FullScreenPostComponent},
  {path: 'content/:day', component: DailyStepsContentMobileV2Component, canActivate: [AuthGuardService]},
  {path: 'weldone', component:WeldonescreenComponent},
  {path: 'mobileweldone', component:MobileWeldonescreenComponent},
  {path: 'path-select', component: PathSelectComponent},
  {path: "uploader", component: AlertProfilePictureComponent},
  {path: 'day-select', component: DayPartSelectComponent},
  {path: 'closeout-welcome', component: CloseoutSurveyWelcomeComponent, canActivate: [AuthGuardService]},
  {path: 'detail-document', component:FullScreenDocumentComponent},
  {path: 'detail-step', component:FullScreenStepComponent},
  {path: 'closeout', component: CloseoutSurveyComponent, canActivate: [AuthGuardService]},
  {path: 'delete-account', component: DeletionPageComponent},
  {path: 'alert-unlock-component', component: AlertUnlockLevelComponent},
  {path: 'detail-reflection', component:FullScreenReflectionComponent},
  {path: 'your-progress', component: YourProgressComponent},
  {path: 'your-path', component: YourPathComponent},
  {path:'daily-content', component: DailyStepsContentWebModalV2Component},
  // {
  //   path: 'main',
  //   component: UpdatedHomeComponent,
  //   canActivateChild: [AuthGuardService],
  //   children: [
  //   {path: '', component: UpdatedHomeComponent},]
  // },
  {
    path: 'main',
     component: UpdatedHomeComponent,
    canActivateChild: [AuthGuardService],
    children: [
    {path: '', component: UpdatedHomeComponent},
    {path: 'questions', component: MobileChatBoardComponent},
    {path: 'stats', component: StatListComponent},
    {path: 'profile', component: UserComponent},
    {path: 'achievements', component: AchievementsPageComponent},
    {path:'routine-details',component:FullScreenRoutineComponent},
    {path: 'notifications-settings', component: NotificationsSettingsComponent},
    {path:'routine-calendar',component:RoutineCalendarComponent},
    {path: 'library', component: MyLibraryComponent},
    { path: '', loadComponent: () => import('./text-screen/text-screen.component').then(m => m.TextScreenComponent) },
    ]
  },
  {path: 'wrong-login', component: WrongLoginLinkComponent},
  {path: 'not-found', component: WrongLoginLinkComponent },
  {path: '**', redirectTo: '/main'},
];

declare const cordova: any
const onCordova = (typeof cordova !== 'undefined' ? true : false)

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,
        initialNavigation: 'enabledNonBlocking'
     })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
